export default "__VITE_ASSET__Lcqa$vbM__"